import { Routes } from '@angular/router';
import { TabTitleStrategyService } from '@sc/data-access-translation';
import {
  CustomerDataFormComponent,
  DeclarationEndComponent,
  InsurerFitterPageComponent,
  InsurerMobileFitterOpeningsPageComponent,
  InterventionComponent,
  SinisterDataFormComponent,
} from './container/declaration/components';
import { DeclarationContainerComponent } from './container/declaration/declaration.container';
import {
  ClaimDataFormGuardCanActivate,
  CustomerDataFormGuardCanActivate,
  DeclarationContainerGuardCanActivate,
  DeclarationEndGuardCanActivate,
  DossierCompleteGuardCanActivate,
  FitterPageGuardCanActivate,
  MobileFitterOpeningsPageGuardCanActivate,
  SinisterDataFormGuardCanActivate,
} from './container/declaration/guards';

export const routes: Routes = [
  {
    path: '',
    component: DeclarationContainerComponent,
    canActivate: [DeclarationContainerGuardCanActivate],
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.insurer.CustomerDataForm',
      sitePlanConfig: {
        passThrough: true,
      },
    },
    children: [
      {
        path: 'customer-data',
        component: CustomerDataFormComponent,
        canActivate: [
          CustomerDataFormGuardCanActivate,
          DossierCompleteGuardCanActivate,
        ],
        data: {
          [TabTitleStrategyService.TAB_TITLE_KEY]:
            'GlobalApplicativeConstants.tabTitles.pageTitles.insurer.CustomerDataForm',
          sitePlanConfig: {
            concatParentPath: true,
          },
        },
      },
      {
        path: 'declaration-end',
        component: DeclarationEndComponent,
        canActivate: [DeclarationEndGuardCanActivate],
        data: {
          [TabTitleStrategyService.TAB_TITLE_KEY]:
            'GlobalApplicativeConstants.tabTitles.pageTitles.insurer.DeclarationEnd',
        },
      },
      {
        path: 'sinister-data',
        component: SinisterDataFormComponent,
        canActivate: [
          SinisterDataFormGuardCanActivate,
          DossierCompleteGuardCanActivate,
        ],
        data: {
          [TabTitleStrategyService.TAB_TITLE_KEY]:
            'GlobalApplicativeConstants.tabTitles.pageTitles.insurer.SinisterData',
        },
      },
      {
        path: 'intervention',
        component: InterventionComponent,
        canActivate: [
          ClaimDataFormGuardCanActivate,
          DossierCompleteGuardCanActivate,
        ],
        data: {
          [TabTitleStrategyService.TAB_TITLE_KEY]:
            'GlobalApplicativeConstants.tabTitles.pageTitles.insurer.AppointmentSearch',
        },
      },
      {
        path: 'fitter/:brandId/:fitterId',
        component: InsurerFitterPageComponent,
        canActivate: [
          FitterPageGuardCanActivate,
          DossierCompleteGuardCanActivate,
        ],
        data: {
          [TabTitleStrategyService.TAB_TITLE_KEY]:
            'GlobalApplicativeConstants.tabTitles.pageTitles.insurer.FitterSearch',
        },
      },
      {
        path: 'openings/:brandId/:fitterId',
        component: InsurerMobileFitterOpeningsPageComponent,
        canActivate: [
          FitterPageGuardCanActivate,
          MobileFitterOpeningsPageGuardCanActivate,
          DossierCompleteGuardCanActivate,
        ],
        data: {
          [TabTitleStrategyService.TAB_TITLE_KEY]:
            'GlobalApplicativeConstants.tabTitles.pageTitles.insurer.FitterOpennings',
        },
      },
    ],
  },
];
